import React from 'react';
import { resolveThemeQuestionDomain } from './resolve-theme-question-domain';

interface Props {
  questionDomain: string | null;
  themeSectorName: string;
  copy: {
    unknownDomain: string;
    questionDomainSource: string;
    themeDomainSource: string;
  };
}

export function ThemeQuestionDomain({ questionDomain, themeSectorName, copy }: Props) {
  const domain = resolveThemeQuestionDomain(questionDomain, themeSectorName);
  const sourceLabel = domain.source === 'question'
    ? copy.questionDomainSource
    : copy.themeDomainSource;

  return (
    <span className="inline-flex min-w-0 items-center gap-1.5 whitespace-nowrap">
      <span className="truncate">{domain.value ?? copy.unknownDomain}</span>
      {domain.source !== 'missing' && <span className="shrink-0 text-[0.62rem] opacity-60">· {sourceLabel}</span>}
    </span>
  );
}
